import { useEffect, useState } from 'react';
import { OrderCompletePage } from './seller/OrderCompletePage';
import { DesktopOrderCompletePage } from './desktop/DesktopOrderCompletePage';

export function ResponsiveOrderCompletePage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile ? <OrderCompletePage /> : <DesktopOrderCompletePage />;
}